import React from "react";
import { withRouteData, Link } from "react-static";
import Moment from "react-moment";
import Markdown from "react-markdown";
import ImageGallery from "react-image-gallery";
import styled from "styled-components";

const StyledTable = styled.table`
  width: 35%;
  td {
    max-width: 33%;
    padding: 10px;
  }
  tr:nth-child(odd) {
    background-color: lightgrey;
  }
  td:nth-child(1) {
    width: 100px;
  }

  @media (max-width: 900px) {
    width: 100%;
  }
`;
const CarPage = styled.div`
  .image-gallery {
    width: 60%;
  }
  @media (max-width: 900px) {
    .image-gallery {
      width: 100%;
    }
  }
`;
const HeaderWrap = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

class Fahrzeug extends React.Component {
  constructor(props) {
    super(props);

    console.log(props);

    this.sliderImages = props.car.data.sliderImages.map(e => ({
      original: e,
      thumbnail: e
    }));
  }

  render() {
    const { car } = this.props;

    return (
      <CarPage>
        <Link to="/Fahrzeuge">Zurück zu allen Fahrzeugen</Link>
        <article key={car.data.slug}>
          <br />
          <Moment format="MMMM Do, YYYY">{car.data.date}</Moment>
          <Link to={`/Fahrzeuge/${car.data.slug}`}>
            <h2>{car.data.title}</h2>
          </Link>
          <HeaderWrap>
            <ImageGallery
              items={this.sliderImages}
              showThumbnails={true}
              showFullscreenButton={true}
              showPlayButton={true}
              showBullets={true}
            />
            <StyledTable>
              <tbody>
                <tr>
                  <td>Marke: </td> <td> {car.data.marke}</td>
                </tr>
                <tr>
                  <td>Model: </td> <td> {car.data.model}</td>
                </tr>

                <tr>
                  <td>Zustand:</td> <td> {car.data.zustand}</td>
                </tr>

                <tr>
                  <td>Baujahr:</td> <td> {car.data.year}</td>
                </tr>

                <tr>
                  <td>Farbe:</td> <td> {car.data.farbe}</td>
                </tr>

                <tr>
                  <td>Türen:</td> <td> {car.data.doors}</td>
                </tr>

                <tr>
                  <td>Kraftstoff:</td> <td> {car.data.kraftstoff}</td>
                </tr>

                <tr>
                  <td>Karosserieform:</td> <td> {car.data.karosserieform}</td>
                </tr>

                <tr>
                  <td>Preis:</td> <td> {car.data.preis}</td>
                </tr>
              </tbody>
            </StyledTable>
          </HeaderWrap>
          <Markdown source={car.content} escapeHtml={false} />
        </article>
      </CarPage>
    );
  }
}

export default withRouteData(({ car }) => <Fahrzeug car={car} />);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Fahrzeug.js